import { Heading } from 'ui/components/primitives/Heading';
import { styled, mixins, theme } from 'ui/theme';

const List = {
  Component: styled.div`
    ${mixins.baseFont};
    color: ${theme.colors.build.darkLight};
    display: grid;
    gap: 1px;
    width: 100%;
    overflow: hidden;

    &[data-rounded='true'] {
      border-radius: ${theme.radii.small};
    }
  `,

  Footer: styled.div`
    background: ${theme.colors.build.lightDark2};
    padding: ${theme.space[6]};
  `,

  Header: styled(Heading)`
    background: ${theme.colors.build.lightDark2};
    padding: ${theme.space[3]} 0 ${theme.space[3]} ${theme.space[6]};
  `,
};

export default List;
